<section id="section-report" class="container-fluid mt-1 ">
  <div class="row" *ngIf="purchaseOrderPrint">
    <div id="container-report" class="col-12 col-lg-12">
      <table id="main-table">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{purchaseOrderPrint.purchaseOrderId}}" class="head col-12 col-lg-12">
                  <!-- Logo -->
                  <img id="logo-{{purchaseOrderPrint.purchaseOrderId}}" [src]="logoEnterprise" alt=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">

                  <!-- Nit Empresa -->
                  <p id="nit-empresa-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{purchaseOrderPrint.enterpriseNit}}</p>

                  <!-- Nombre Empresa -->
                  <p id="nombre-empresa-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{purchaseOrderPrint.enterpriseName}}</p>

                  <!-- Nombre Sucursal -->
                  <p id="nombre-sucursal-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{purchaseOrderPrint.branchName}}</p>

                  <!-- Dirección Sucursal -->
                  <p id="direccion-sucursal-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{purchaseOrderPrint.branchAddress}}</p>

                  <!-- Telefono Sucursal -->
                  <p id="telefono-sucursal-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{purchaseOrderPrint.branchPhone}}</p>

                  <!-- Nombre Pedido -->
                  <p id="nombre-orden-compra-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    Orden Compra Nro.{{purchaseOrderPrint.consecutive}}</p>

                  <!-- Fecha  -->
                  <label id="t-fecha-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-fecha' | formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{purchaseOrderPrint.datePurchaseOrder | date: 'dd/MM/yyyy'}}</p>

                  <!-- Documento Referencia -->
                  <label id="t-docum-referencia-{{purchaseOrderPrint.purchaseOrderId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-docum-referencia' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="docum-referencia-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{purchaseOrderPrint.referenceDocument}}</p>

                  <!-- Nit Proveedor -->
                  <label id="t-nit-proveedor-{{purchaseOrderPrint.purchaseOrderId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-nit-proveedor' | formatLabelPipe
                    :
                    elementsLabel}}</label>
                  <p id="nit-proveedor-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{purchaseOrderPrint.providerNit}}</p>

                  <!-- Nombre Proveedor -->
                  <label id="t-nombre-proveedor-{{purchaseOrderPrint.purchaseOrderId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-nombre-proveedor' |
                    formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="nombre-proveedor-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{purchaseOrderPrint.providerBusinessName}}</p>

                  <!-- Dirección Proveedor -->
                  <label id="t-direccion-proveedor-{{purchaseOrderPrint.purchaseOrderId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-direccion-proveedor' |
                    formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="direccion-proveedor-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{purchaseOrderPrint.providerAddress}}</p>

                  <!-- Telefono Proveedor -->
                  <label id="t-telefono-proveedor-{{purchaseOrderPrint.purchaseOrderId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-telefono-proveedor' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="telefono-proveedor-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{purchaseOrderPrint.providerPhone}}</p>

                  <!--Nit Empresa 2-->
                  <label id="t-nit-empresa-2-{{purchaseOrderPrint.purchaseOrderId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-nit-empresa-2' | formatLabelPipe
                    : elementsLabel}}</label>
                  <p id="nit-empresa-2-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{purchaseOrderPrint.enterpriseNit2}}</p>

                  <!--Nombre Empresa 2-->
                  <label id="t-nombre-empresa-2-{{purchaseOrderPrint.purchaseOrderId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-nombre-empresa-2' |
                    formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="nombre-empresa-2-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{purchaseOrderPrint.enterpriseName2}}</p>

                  <!--telefono Empresa 2-->
                  <label id="t-telefono-sucursal-2-{{purchaseOrderPrint.purchaseOrderId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-telefono-sucursal-2' |
                    formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="telefono-sucursal-2-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{purchaseOrderPrint.branchPhone2}}</p>

                  <!-- Dirección-->
                  <label id="t-direccion-{{purchaseOrderPrint.purchaseOrderId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-direccion' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="direccion-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{purchaseOrderPrint.address}}</p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <app-custom-table-print id="detalle-orden-compra-{{purchaseOrderPrint.purchaseOrderId}}"
                  [columns]="columns" [data]="purchaseOrderPrint.purchaseOrderDetails" [idMap]="idMap"
                  [documentId]="purchaseOrderPrint.purchaseOrderId" [footerVisible]="false" [editFormat]="editFormat"
                  (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>

                <div id="container-totals">
                  <div id="totals">
                    <div class="row d-flex justify-content-start totalRegContainer">
                      <!-- Total registros -->
                      <p id="foot-total-reg-{{purchaseOrderPrint.purchaseOrderId}}" class="totalReg" (click)="onClick()"
                        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                        Total Reg: {{totalRegDetail}}
                      </p>
                    </div>

                    <!-- subtotal -->
                    <div class="row d-flex justify-content-end">
                      <label id="foot-t-subtotal-{{purchaseOrderPrint.purchaseOrderId}}" for=""
                        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()" class="">{{'foot-t-subtotal' |
                        formatLabelPipe :
                        elementsLabel}}</label>
                      <p id="foot-subtotal-{{purchaseOrderPrint.purchaseOrderId}}" (click)="onClick()"
                        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                        {{purchaseOrderPrint.subtotalValue | currency}}</p>
                    </div>

                    <!-- Valor Iva -->
                    <div class="row d-flex justify-content-end">
                      <label id="foot-t-valor-iva-{{purchaseOrderPrint.purchaseOrderId}}" for=""
                        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()" class="">{{'foot-t-valor-iva' |
                        formatLabelPipe :
                        elementsLabel}}</label>
                      <p id="foot-valor-iva-{{purchaseOrderPrint.purchaseOrderId}}" (click)="onClick()"
                        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                        {{purchaseOrderPrint.ivaValue | currency}}</p>
                    </div>

                    <!-- Total -->
                    <div class="row d-flex justify-content-end">
                      <label id="foot-t-total-{{purchaseOrderPrint.purchaseOrderId}}" for=""
                        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()" class="">{{'foot-t-total' |
                        formatLabelPipe :
                        elementsLabel}}</label>
                      <p id="foot-total-{{purchaseOrderPrint.purchaseOrderId}}" (click)="onClick()"
                        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                        {{purchaseOrderPrint.totalValue | currency}}</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Observaciones -->
              <div id="foot-{{purchaseOrderPrint.purchaseOrderId}}" class="foot container-observations">
                <!-- Observacion -->
                <label id="t-observacion-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()" *ngIf="purchaseOrderPrint.observation">{{'t-observacion' | formatLabelPipe
                  : elementsLabel}}</label>
                <p id="observacion-{{purchaseOrderPrint.purchaseOrderId}}" class="lh-1"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()" *ngIf="purchaseOrderPrint.observation">
                  {{purchaseOrderPrint.observation}}</p>

                <label id="t-remisiono-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-remisiono' | formatLabelPipe : elementsLabel}}</label>
                <label id="t-linea-remisiono-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-linea-remisiono' | formatLabelPipe : elementsLabel}}</label>

                <label id="t-aprobo-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-aprobo' | formatLabelPipe : elementsLabel}}</label>
                <label id="t-linea-aprobo-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-linea-aprobo' | formatLabelPipe : elementsLabel}}</label>

                <label id="t-despacho-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-despacho' | formatLabelPipe : elementsLabel}}</label>
                <label id="t-linea-despacho-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-linea-despacho' | formatLabelPipe : elementsLabel}}</label>

                <label id="t-recibio-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-recibio' | formatLabelPipe : elementsLabel}}</label>
                <label id="t-linea-recibio-{{purchaseOrderPrint.purchaseOrderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-linea-recibio' | formatLabelPipe : elementsLabel}}</label>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="1">
              <div id="td-foot" class="information-print d-flex">
                <!-- Versión-->
                <p id="version-cervino" class="fw-bold pe-4 ">{{version}}</p>

                <!-- Fecha Impresión-->
                <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha:</label>
                <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>

                <!-- Hora Impresión-->
                <label id="t-hora-impresion" class="fw-bold pe-2">Hora:</label>
                <p id="hora-impresion" class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>

                <!-- Usuario Impresión-->
                <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario:</label>
                <p id="usuario-impresion" class="pe-4"> {{userAuthenticated}}</p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="d-flex justify-content-center">
                  <p class="mt-2 information-print">Documento generado con el Software Cervino Web de Altos Software
                    SAS.
                    Nit.811.022.121-1. www.altos-soft.com</p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>